export const footer: FooterSetup = {
    buttonLabel: 'Give us feedback',
    buttonLink: 'https://kromatic.com/feedback?app=portfolio-manager',
    links: [
        {
            label: 'Privacy Policy',
            href: 'https://kromatic.com/privacy-policy',
        },
        {
            label: 'Terms of Service',
            href: 'https://kromatic.com/terms-of-service',
        },
    ],
    poweredBy: true,
};
